<div class="mail-details">
  <div class="email-headers">
    <p><span class="header-title">From: </span>{{from}}</p>
    <p><span class="header-title">To: </span>{{to}}</p>
    <p><span class="header-title">Subject: </span>{{subject}}</p>
    <p><span class="header-title">Received: </span>{{sentDate | wmCalendarFormat}}</p>
  </div>
  @if (!!body) {
    <div class="body">
      @if (!!hasHtmlBody) {
        <iframe #htmlFrame sandbox="allow-popups allow-same-origin" style="overflow:hidden;" [srcdoc]="htmlBody" (load)="onIframeLoad(htmlFrame)"></iframe>
      }
      @if (!hasHtmlBody) {
        <p class="text-content">{{body}}</p>
      }
    </div>
  }
  @if (pixelSrcs.length != 0) {
    <div class="pixels">
      <p><span class="header-title">Analytics: </span></p>
      @for (pixelSrc of pixelSrcs; track pixelSrc) {
        <div class="pixel-src">
          <code>{{pixelSrc}}</code>
        </div>
      }
    </div>
  }
</div>
